// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"781":"364bedfc252024032ed4","943":"a577a5ca3fd0340734da"}[chunkId] + ".chunk.js";
};